import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { enLanguage } from 'src/assets/language/en';
import { trLanguage } from 'src/assets/language/tr';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(
    private translate: TranslateService
  ) { }

  loadTranslation(lang?: string) {
    if (!lang) {
      const currentUrl = window.location.href;
      if (currentUrl.includes('/en')) {
        lang = 'en';
      }
      else {
        lang = 'tr';
      }
    }

    document.documentElement.lang = lang;

    let language;
    if (lang == 'tr') {
      language = trLanguage;
    }
    else if (lang == 'en') {
      language = enLanguage;
    }

    if (language) {
      this.translate.setTranslation(lang, language, true);
    }
  }
}